import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../../../routes/routes';
import { ChannelIcon } from '../../../components/channel';
import { ChannelType } from '../../../types';

type ActionChannelListProps = {
  channels: ChannelType[];
};

export const ActionChannelList: React.FC<ActionChannelListProps> = ({ channels }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('action');

  return (
    <div className="action-device-list">
      <div className="action-device-list__header">
        <h3>{t('basic.control')}</h3>
      </div>
      {channels && channels.length > 0 && (
        <div className="action-device-list__list">
          {channels.map((channel) => (
            <div
              onClick={() => navigate(ROUTES.ChannelDetails(channel.id))}
              key={channel.id}
              className="device-item"
            >
              <h4 className="device-item__header">
                <div className="icon-box box">
                  <ChannelIcon channel={channel} />
                </div>
                <div className="device-item__content-wrapper">
                  <span className="device-item__name">{channel.alias}</span>
                </div>
              </h4>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
